import React, { useState } from "react";
import { NamedLink } from "../../../../components";
import image1 from "../../../../assets/image1.jpeg";
import image2 from "../../../../assets/image2.jpeg";
import image3 from "../../../../assets/image3.jpeg";
import css from "./GainByJoin.module.css";

const GainByJoining = ({mainCss}) => {
  const [flippedIndex, setFlippedIndex] = useState(null);

  const handleFlip = (index) => {
    setFlippedIndex(flippedIndex === index ? null : index);
  };

  const cards = [
    {
      image: image1,
      title: "¿Qué ganas al darte de alta?",
      buttonText: "ORIGEN",
      content: {
        title: "Beneficios principales",
        points: [
          {
            heading: "Prueba sin compromiso.",
            line:
              " Da a conocer tu producción. Y comprueba tú mismo que se puede vender más… sin venderte.",
          },
          {
            heading: "Ganas visibilidad real:",
            line:
              " Aparece entre los primeros si te recomiendan y promociona tu perfil.",
          },
          {
            heading: "Tú eliges el precio, el ritmo y el horario:",
            line:
              " Define días de recogida y actualiza tu cosecha al momento.",
          },
          {
            heading: "Sin requisitos imposibles:",
            line:
              " ¿Ecológicos? Bienvenidos. ¿Sin sello pero con alma? También.",
          },
        ],
      },
    },
    {
      image: image2,
      title: "¿Y los ingresos?",
      buttonText: "SIN INTERMEDIARIOS",
      content: {
        title: "Tú te llevas el 100%",
        points: [
          {
            line:
              "Imagina esto: Si BioCerca llega a 10.000 consumidores activos… y tú vendes solo a un 1% cada mes… podrían ser 100 pedidos directos.",
          },
          {
            heading: "Todo el valor de la compra te lo llevas tú.",
            line:
              " Con un margen más justo, vendiendo incluso productos que hoy tirarías… puedes ganar más con menos. Y vivir mejor.",
          },
        ],
      },
    },
    {
      image: image3,
      title: "¿Y después de los 3 meses?",
      buttonText: "CERCANIA",
      content: (
        <section className={`${css.section} ${css.featuresSection}`}>
          <div className={css.feesTableContainer}>
            <p className={css.feesNote}>* Detalle de cuotas:</p>

            <table className={css.feesTable}>
              <thead>
                <tr>
                  <th>Mes</th>
                  <th>Cuota mensual</th>
                  <th>Comentario</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1–3</td>
                  <td>0€</td>
                  <td>Periodo de prueba gratuito, sin compromiso</td>
                </tr>
                <tr>
                  <td>4–6</td>
                  <td>19€/mes</td>
                  <td>Entrada suave, empiezan a ver resultados</td>
                </tr>
                <tr>
                  <td>7–9</td>
                  <td>29€/mes</td>
                  <td>Ya conocen el funcionamiento, es sostenible</td>
                </tr>
                <tr>
                  <td>10–12</td>
                  <td>39€/mes</td>
                  <td>Ajuste gradual hacia la cuota final</td>
                </tr>
                <tr>
                  <td>A partir del 13</td>
                  <td>49€/mes</td>
                  <td>
                    Cuota definitiva, con opción de incluir mejoras Premium
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div style={{ textAlign: "center", marginTop: "48px" }}>
            <NamedLink name="SignupPage" className={css.infoButton}>
              Empieza GRATIS ahora
            </NamedLink>
          </div>
        </section>
      ),
    },
  ];

  return (
    <section className={css.pageWrapper}>
      <div className={css.cardWrapper}>
        {cards.map((card, index) => (
          <div
            key={index}
            className={`${css.card} ${
              flippedIndex === index ? css.flipped : ""
            }`}
          >
            <div className={css.cardInner}>
              {/* FRONT */}
              <div className={css.cardFront}>
                <img src={card.image} alt={card.title} />
                <div className={css.overlay}>
                  <h3>{card.title}</h3>
                  <button onClick={() => handleFlip(index)}>
                    {card.buttonText}
                  </button>
                </div>
              </div>

              {/* BACK */}
              <div className={css.cardBack}>
                {/* DATA CONTENT */}
                {typeof card.content === "object" &&
                !React.isValidElement(card.content) ? (
                  <>
                    <h4>{card.content.title}</h4>
                    <ul>
                      {card.content.points.map((point, i) => (
                        <li key={i}>
                          {point.heading && (
                            <strong>{point.heading}</strong>
                          )}
                          {point.line}
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  /* JSX CONTENT */
                  card.content
                )}

                <button onClick={() => handleFlip(index)}>Cerrar</button>
              </div>
            </div>
          </div>
        ))}
      </div>
       <div className={mainCss.commissionNote}>
                  <p>
                    En BioCerca, cada euro que pagas va íntegro al agricultor. Solo añadimos 1,5 €
                    por compra para mantener viva esta plataforma sin intermediarios, sin publicidad
                    y con la garantía de que seguirás comprando directo, fácil y seguro. Es tu forma
                    de apoyar un sistema justo, donde tú eliges, y el campo recibe lo que merece.
                  </p>
                </div>
    </section>
  );
};

export default GainByJoining;
